import './index.erb';
import './index.rb';

import './filter_questions.erb';
import './search_question.erb';

export default class InterventionBanner {
  constructor() {
    this.searchValues = '';
    this.bind();
  }

  get filterBtn() {
    return $('.js-intervention-banner-question');
  }

  get searchInput() {
    return $('.js-intervention-banner-search-questions-input');
  }

  get searchBtn() {
    return $('.js-intervention-banner-search-questions-icon');
  }

  get productPath() {
    return $('.js-intervention-banner-search-questions-input').data(
      'questions-path'
    );
  }

  get isBtnEnabled() {
    return !this.searchBtn.hasClass('disabled');
  }

  searchQuestions() {
    const params = encodeURIComponent(this.searchValues);

    if (this.isBtnEnabled) {
      Turbolinks.visit(`${this.productPath}?q=${params}`);
    }
  }

  setInputData(e) {
    if (e.key === 'Enter') {
      return this.searchQuestions();
    }

    this.toggleBtnClass(!e.target.value);
    this.searchValues = e.target.value;
  }

  toggleBtnClass(boolean) {
    boolean
      ? this.searchBtn.addClass('disabled')
      : this.searchBtn.removeClass('disabled');
  }

  bindSearch() {
    this.searchInput.on('keyup', (e) => this.setInputData(e));
    this.searchBtn.on('click', () => this.searchQuestions());
  }

  bind() {
    this.bindSearch();
  }
}

new InterventionBanner();
